<template>
    <div class="contest">
        <v-container class="custom-container">
            <v-row dense>
                <v-col cols="12">
                    <v-card class="pa-5 pb-0" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="7" lg="7">
                                <v-card class="elevation-0 px-5 py-3 rounded-0 finished-content"
                                    :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                                    <v-card-actions class="title custom-border-bottom">
                                        <h3>Leaderboard</h3>
                                        <p>Total Contestant : <span>{{ finishedcontest?.total_contestants || 0 }}</span>
                                        </p>
                                    </v-card-actions>
                                    <v-card-actions class="title custom-border-bottom">
                                        <h4 class="bg-danger">Finished Contest</h4>
                                        <div class="text-right">
                                            <p>Finishing Timer </p>
                                            <timer-view></timer-view>
                                        </div>
                                    </v-card-actions>
                                </v-card>
                                <v-row dense>
                                    <v-col v-for="(performer, index) in finishedcontest.top_performers" :key="index"
                                        cols="12" sm="12" md="6" lg="4">
                                        <v-card class="elevation-0 rounded-0 winner-card"
                                            :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                                            <div class="winner">
                                                <div class="profile">
                                                    <div class="user-img">
                                                        <img class="user" :src="getRankImage(index + 1)"
                                                            alt="profile-img">
                                                        <img class="rank-img" :src="getContestImage(index + 1)"
                                                            alt="profile-img">
                                                    </div>
                                                    <div class="content">
                                                        <h3>Rank {{ performer.rank }}</h3>
                                                        <h4 class="text-truncate">{{ performer.participant_name }}</h4>
                                                    </div>
                                                </div>
                                                <div class="message">
                                                    <v-btn :ripple="false" elevation class="ma-2" to="/support"
                                                        color="#039de91A">
                                                        <v-icon color="#039de9">
                                                            mdi mdi-chat-outline
                                                        </v-icon>
                                                    </v-btn>

                                                </div>
                                            </div>
                                            <p>Got : ${{ formatProfit(performer.total_profit) }}</p>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <finished-data-table :participants="finishedcontest.participants"></finished-data-table>
                            </v-col>
                            <v-col cols="12" sm="6" md="5" lg="5">
                                <finished-contest-card :contest="finishedcontest"></finished-contest-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AddContestModal from '@/components/Contest/AddContestModal.vue';
import ContestCard from '@/components/Contest/ContestCard.vue';
import FinishedContestCard from '@/components/Contest/FinishedContestCard.vue';
import FinishedDataTable from '@/components/Contest/FinishedDataTable.vue';
import TimerView from '@/components/Contest/TimerView.vue';
import { CONTEST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
    components: { AddContestModal, ContestCard, TimerView, FinishedDataTable, FinishedContestCard },
    computed: {
        ...mapState("contest", ["finishedcontest"]),
    },
    methods: {
        ...mapActions("contest", [CONTEST__ACTIONS.VIEWFINISHEDCONTEST]),
        getRankImage(rank) {
            return require(`@/assets/rank-${rank}.png`)
        },

        getContestImage(rank) {
            return require(`@/assets/contest-${rank}.png`)
        },

        formatProfit(profit) {
            return profit.toFixed(2)
        },
    },
    async mounted() {
        this[CONTEST__ACTIONS.VIEWFINISHEDCONTEST](this.$route.query.id);
    }
}
</script>
